
function game_5007()
{

}

game_5007.odd_map  = {
  "W":[0,0,20,80,600],
  "P4":[0,0,20,80,600],
  "P3":[0,0,20,60,400],
  "P2":[0,0,15,50,300],
  "P1":[0,0,15,40,200],
  "A":[0,0,10,20,80],
  "K":[0,0,10,20,80],
  "Q":[0,0,5,15,60],
  "J":[0,0,5,15,60],
};
game_5007.mul_array  = [

]

export {
  game_5007
};



// WEBPACK FOOTER //
// ./src/components/slots/game_5007.js